import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';

@Pipe({
    standalone: false,
    name: 'bringozPackageCustomDataDisplay'
})
export class BringozPackageCustomDataDisplayPipe implements PipeTransform {

    transform(packageItem: any, packageDynamicColumn: any): string {
        if (!packageItem) {
            return '---';
        }

        const match = _.find(packageItem.configuredFields || [], (cf) => {
            return cf.id === packageDynamicColumn.id || cf.packageFieldId === packageDynamicColumn.id || cf.fieldName === packageDynamicColumn.title;
        });

        return match?.value || '---';
    }
}
